<div class="cd-multidropdown" appOutsideClose (outsideEvent)="onOutsideEvent()" [class.with-label]="!!label">
  @if (!!label) {
  <div class="label cds-body2">
    {{ label }}
  </div>
  }

  <div class="selected-val-box">
    <input
      [value]="getTitle"
      [ngClass]="['selected-val', disabled ? 'disabled-selected-val' : '']"
      type="text"
      readonly
      [placeholder]="placeholder | lang"
      (click)="onToggel()" />
    <cds-icon (click)="onToggel()" [ngClass]="['button-down', open ? 'up' : '', disabled ? 'disabled-button-down' : '']" icon="action:button_down"></cds-icon>
  </div>

  <div [ngClass]="['line', open ? 'line-light' : '', disabled ? 'disabled-line' : '']"></div>

  <div [ngClass]="['option-list', open ? 'open-list' : '', !!label ? 'top-position' : '']">
    @for (item of toppingList; track item) {
    <div class="option-item" (click)="refrushToppings(item)">
      <cds-checkbox [checked]="getCheck(item)" [label]="item.label | lang"> </cds-checkbox>
      <div class="l-ml-7">
        @if (item.subLabel) {
        <div>{{ item.subLabel }}</div>
        } @if (item.exatraInfo) {
        <div class="cds-detail1">
          {{ item.exatraInfo }}
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
